import { get, isNil, omitBy } from 'lodash';
import { reportSnippetClickEvent } from '../../utils/reports/snippet';
import { FILTER_TYPES } from '../../constants';
import fetchReviewsAction from '../apiActions/fetchReviews';
import {
    UPDATE_BREAKDOWN_SELECTED,
    UPDATE_FILTER_SELECTED,
    UPDATE_INDUSTRY_DROPDOWN_SELECTION,
    UPDATE_REVIEWS,
    UPDATE_WORK_SAMPLE_SELECTED,
    UPDATE_BUSINESS_SELECTED,
    CLEAR_ALL_FILTERS,
} from './types';

const industryEmptyValue = (industryValue) => isNil(industryValue) || industryValue === 0;

export const updateReviews = (list, filterType, isFilter) => ({
    type: UPDATE_REVIEWS,
    filterType,
    isFilter,
    list,
});

export const updateBreakdownSelected = (selected) => ({
    type: UPDATE_BREAKDOWN_SELECTED,
    value: selected,
});

export const updateFilterSelected = (filters) => ({
    type: UPDATE_FILTER_SELECTED,
    value: filters,
});

export const clearAllFilters = () => ({
    type: CLEAR_ALL_FILTERS,
});

export const updateWorkSampleSelected = (checked) => ({
    type: UPDATE_WORK_SAMPLE_SELECTED,
    value: checked,
});

export const updateBusinessSelected = (checked) => ({
    type: UPDATE_BUSINESS_SELECTED,
    value: checked,
});

export const updateIndustryDropdownSelected = (value) => ({
    type: UPDATE_INDUSTRY_DROPDOWN_SELECTION,
    value,
});

export const toggleSelectedStars = (selected) => (dispatch, getState) => {
    const filterValue = toggleSelectedStarsState(selected)(dispatch, getState);
    return toggleSelectedFilterState(FILTER_TYPES.breakdown, filterValue)(dispatch, getState);
};

export const toggleSelectedStarsState = (selected) => (dispatch, getState) => {
    const state = getState();
    const selectedStars = state.selectedStars || [];
    let updatedSelectedStars;
    let filterValue = false;

    if (selectedStars.includes(selected)) {
        updatedSelectedStars = selectedStars.filter((item) => item !== selected);
    } else if (selected) {
        updatedSelectedStars = [selected];
        filterValue = true;
    } else {
        updatedSelectedStars = [];
    }

    dispatch(updateBreakdownSelected(updatedSelectedStars));
    return filterValue;
};

export const toggleSelectedFilterState = (filter, value) => (dispatch, getState) => {
    const state = getState();
    const updatedFilters = {};
    updatedFilters[filter] = value;

    dispatch(updateFilterSelected(updatedFilters));

    return fetchReviews({
        filterType: state.type,
        isFilter: true,
    })(dispatch, getState);
};

export const toggleWorkSample = (selected) => (dispatch, getState) => {
    toggleWorkSampleState(selected)(dispatch);
    return toggleSelectedFilterState(FILTER_TYPES.work_sample, selected)(dispatch, getState);
};

export const toggleBusiness = (selected) => (dispatch, getState) => {
    toggleBusinessState(selected)(dispatch);
    return toggleSelectedFilterState(FILTER_TYPES.business, selected)(dispatch, getState);
};

export const toggleIndustrySelection = (selected) => (dispatch, getState) => {
    toggleIndustrySelectionState(selected)(dispatch);
    return toggleSelectedFilterState(FILTER_TYPES.industry, selected)(dispatch, getState);
};

export const toggleWorkSampleState = (selected) => (dispatch) => dispatch(updateWorkSampleSelected(selected));
export const toggleBusinessState = (selected) => (dispatch) => dispatch(updateBusinessSelected(selected));
export const toggleIndustrySelectionState = (selected) => (dispatch) =>
    dispatch(updateIndustryDropdownSelected(selected));
export const setSearchTerm = (searchTerm) => (dispatch, getState) =>
    toggleSelectedFilterState(FILTER_TYPES.text, searchTerm)(dispatch, getState);

export const clearFilters = () => (dispatch, getState) => {
    const state = getState();

    toggleSelectedStarsState()(dispatch, getState);
    toggleWorkSampleState(false)(dispatch);
    toggleBusinessState(false)(dispatch);
    toggleIndustrySelectionState(null)(dispatch);
    dispatch(clearAllFilters());

    return fetchReviews({
        filterType: state.type,
        isFilter: true,
    })(dispatch, getState);
};

export const onSnippetClickEvent = ({ review, type }) => {
    const eventData = {
        encryptedOrderId: review.encrypted_order_id,
    };

    reportSnippetClickEvent(type, eventData);
};

export const getCurrentUserIndustries = (state) =>
    omitBy(get(state, 'filters_counters.current_user_industries', {}), industryEmptyValue);

export const getMostCommonIndustries = (state) =>
    omitBy(get(state, 'filters_counters.most_common_industries', {}), industryEmptyValue);

export const getCurrentUserIndustriesInitial = (state) =>
    omitBy(get(state, 'filtersCountersInitial.current_user_industries', {}), industryEmptyValue);

export const getMostCommonIndustriesInitial = (state) =>
    omitBy(get(state, 'filtersCountersInitial.most_common_industries', {}), industryEmptyValue);

export const fetchReviews = fetchReviewsAction;
